import script from "./Reemplazos_Fuera_Servicio.vue?vue&type=script&setup=true&lang=js"
export * from "./Reemplazos_Fuera_Servicio.vue?vue&type=script&setup=true&lang=js"

import "./Reemplazos_Fuera_Servicio.vue?vue&type=style&index=0&id=35660604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35660604"]])

export default __exports__